var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFfLogoutIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00001 6.33643C0.63182 6.33643 0.333343 6.6349 0.333343 7.00309C0.333343 7.37128 0.63182 7.66976 1.00001 7.66976L8.05443 7.66976L6.19527 9.52892C5.93492 9.78927 5.93492 10.2114 6.19527 10.4717C6.45562 10.7321 6.87773 10.7321 7.13808 10.4717L10.1005 7.50932C10.243 7.38705 10.3333 7.20562 10.3333 7.00309L10.3333 7.00174C10.3337 6.83066 10.2686 6.65946 10.1381 6.52892L7.13808 3.52892C6.87773 3.26857 6.45562 3.26857 6.19527 3.52892C5.93492 3.78927 5.93492 4.21138 6.19527 4.47173L8.05997 6.33643L1.00001 6.33643Z",
    fill: "#505B73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33334 1.00032C6.33334 0.632135 6.63182 0.333658 7.00001 0.333658L13 0.333658C13.3682 0.333658 13.6667 0.632135 13.6667 1.00032L13.6667 13.0003C13.6667 13.3685 13.3682 13.667 13 13.667L7.00278 13.667C6.63459 13.667 6.33611 13.3685 6.33611 13.0003C6.33611 12.6321 6.63459 12.3337 7.00278 12.3337L12.3333 12.3337L12.3333 1.66699L7.00001 1.66699C6.63182 1.66699 6.33334 1.36851 6.33334 1.00032Z",
    fill: "#505B73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfLogoutIcon);
export default __webpack_public_path__ + "static/media/ff-logout-icon.5444673b880854eec25995aef6b2d9a6.svg";
export { ForwardRef as ReactComponent };